import { Component, OnInit, Inject, Input } from '@angular/core';
import { CorrespondenceTimelineService } from '../../../../shared/services/correspondence-timeline.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-archived-timeline-item-list',
  templateUrl: './archived-timeline-item-list.component.html',
  styleUrls: ['./archived-timeline-item-list.component.scss']
})
export class ArchivedTimelineItemListComponent implements OnInit {

  @Input() caseId: number;
  archivedItems: any[] = [];

  displayedColumns: string[] = ['correspondenceType', 'source', 'summary', 'dateCreated', 'addedByUser', 'archivedDate', 'archivedByUser', 'archivedReason'];

  constructor(
    public activeModal: NgbActiveModal,
    private correspondenceTimelineService: CorrespondenceTimelineService) {
  }

  ngOnInit(): void {
    this.correspondenceTimelineService.getArchivedCorrespondenceTimelineItems(this.caseId).subscribe(response => {
      this.archivedItems = response.items;
    });
  }

  formatDateWithTime(inDate : any){

    var formattedDate = '';


     if(inDate !== null)
     {

       var dt = DateTime.fromISO(inDate);

       formattedDate = dt.toFormat("dd-MM-yyyy HH:mm:ss");

     if(formattedDate == 'Invalid date')
       formattedDate = '';

     }


     return formattedDate;

   }
}
